import styled from "styled-components"
import {InputGroup} from "react-bootstrap"
import IconText from "../../IconText"

export const InputGroupAddon = styled(InputGroup)`
  margin-top: ${({theme}) => theme.spacing.one};
`

export const StyledIconText = styled(IconText)`
  path:last-child {
    fill: ${({theme}) => theme.colors.greys.white};
  }
`
